module.exports = __webpack_public_path__ + "static/exam-result-couple-4ee275331316e27f867e92da62ac3f53.svg";